
import React from "react";
import "./Loading.css";
import { useGlobalContext } from "../../context";
import ReactModal from "react-modal";
import load from "../../Assets/hhhhh.gif";

function Loading() {

    const {
        loading
    } = useGlobalContext()

    return (
        <ReactModal
            isOpen = { loading }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor:'rgba(0, 0, 0, 0.3)',
                    zIndex: 999,
                },
                content: {
                    width: "50%",
                    minWidth: "300px",
                    height: "auto",
                    border: 'none',
                    margin: "auto",
                    background: 'none',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }
            }}
        >
            <img src = { load }  className = "loader-image" alt = 'Loading image'/>
        </ReactModal>
    )
}

export default Loading

